import { NhostClient } from "@nhost/nhost-js";
import { NhostProvider } from "@nhost/react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import CreatePost from "./pages/blogPost/CreatePost";
import EditPost from "./pages/blogPost/EditPost";
import PostByUser from "./pages/blogPost/PostByUser";
import SinglePost from "./pages/blogPost/SinglePost";
import Home from "./pages/Home/Home";
import Navbar from "./pages/Navbar/Navbar";
import ProtectedRoute from "./pages/ProtectedRoute";
import SignIn from "./pages/user/SignIn";
import SignUp from "./pages/user/SignUP";

const nhost = new NhostClient({
  subdomain: process.env.REACT_APP_NHOST_SUBDOMAIN,
  region: process.env.REACT_APP_NHOST_REGION,
});

function App() {
  return (
    <NhostProvider nhost={nhost}>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/" element={<Home />} />
          <Route path="/:id" element={<SinglePost />} />
          <Route
            path="/createPost"
            element={
              <ProtectedRoute>
                <CreatePost />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="/editPost"
            element={
              <ProtectedRoute>
                <EditPost />
              </ProtectedRoute>
            }
          ></Route>
          <Route
            path="/myPost"
            element={
              <ProtectedRoute>
                <PostByUser />
              </ProtectedRoute>
            }
          ></Route>
        </Routes>
      </BrowserRouter>
    </NhostProvider>
  );
}

export default App;
